import { Route } from "vue-router/types/router";
import { AppSessionStorage } from "@/lib/appStorage";

class HistoryManager {
  private history: string[] = [];

  private historyKey = "scrile-connect.HistoryManager.history";

  private replace = false;

  public constructor() {
    this.readState();
  }

  public setReplace() {
    this.replace = true;
  }

  public hasHistory() {
    // const route = this.router.resolve(this.history[this.history.length - 1]);
    return this.history.length > 1;
  }

  public afterEachGuard(to: Route, from: Route) {
    if (this.replace) {
      this.replace = false;
      this.history.splice(this.history.length - 1, 1, to.fullPath);
    } else if (this.recentPath(to.fullPath, from.fullPath)) {
      this.history.pop();
    } else if (this.history[this.history.length - 1] !== to.fullPath) {
      this.history.push(to.fullPath);
    }
    this.saveState();
  }

  private recentPath(to: string, from: string): boolean {
    const latsIndex = this.history.length - 1;
    return this.history[latsIndex] === from && this.history[latsIndex - 1] === to;
  }

  private saveState() {
    AppSessionStorage.setString(this.historyKey, JSON.stringify(this.history));
  }
  private readState() {
    const getValue = AppSessionStorage.getString(this.historyKey, "[]");
    if (getValue) this.history = JSON.parse(getValue);
  }
}

export default new HistoryManager();
